import { FC } from 'react';
import { useRouter } from 'next/router';
import EditorImg from 'lowcode/components/EditorImg';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import { useDP3Store } from '../../DP3Provider';
import css from './index.module.scss';
import gtm from '@/utils/gtm';

const TheComp: FC = () => {
    const { pageStatus } = useDP3Store();
    const { locale = 'us' } = useRouter();
    const isTEASER = pageStatus === IPageStatus.statusA;
    const idObj: any = {
        jp: '#dp3-SubscribeA',
        us: '#dp3-teaser-B',
    };
    const idHref = idObj[locale] || idObj.us;
    const TEXT_MAP: any = {
        jp: '今すぐ登録',
        us: 'Sign Up\nNow!',
    };
    const textTeaser = TEXT_MAP[locale] || TEXT_MAP.us;

    // 众筹
    const TEXT_MAP2: any = {
        jp: '今すぐ登録',
        us: 'Get up to $250 Cashback When You Refer A Friend!',
    };
    const textCrowdfunding = TEXT_MAP2[locale] || TEXT_MAP2.us;
    // 最后选择
    const textLast = isTEASER ? textTeaser : textCrowdfunding;
    return (
        <div className={`${css.thecomp} pageStatus-${pageStatus}`}>
            <a
                href={idHref}
                className="BarIconR-in"
                onClick={() => {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'floating_button',
                        button_name: 'Subsription',
                    });
                }}
            >
                {/* <IconA /> */}
                <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717231766931/icon_email.png" />
                <div className="text-btn">{textLast}</div>
            </a>
        </div>
    );
};

export default TheComp;
